import React from 'react'
import {createSvgIcon} from "@mui/material"

export default createSvgIcon(
    <svg width="32" height="32" viewBox="2 2 12 12" xmlns="http://www.w3.org/2000/svg">
        <path fill="currentColor" d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
    </svg>, "add"
)
